import { hasSuperUserAccess } from './sessionUser';

export function isHiddenStudent(row) {
  if (!row || typeof row !== 'object') return false;
  const v = row.isHiddenStudent ?? row.is_hidden_student;
  return v === true || v === 'true' || v === 1;
}

/** Hidden students appear in lists only for true super users (not demo mode). */
export function maySeeHiddenStudentsInLists(user) {
  return hasSuperUserAccess(user);
}

export function filterStudentsForViewer(user, rows) {
  if (!Array.isArray(rows)) return [];
  if (maySeeHiddenStudentsInLists(user)) return rows;
  return rows.filter((row) => !isHiddenStudent(row));
}
